import { render } from "./ClientHome.vue?vue&type=template&id=1e8c17d2&scoped=true"
import script from "./ClientHome.vue?vue&type=script&lang=js"
export * from "./ClientHome.vue?vue&type=script&lang=js"

import "./ClientHome.vue?vue&type=style&index=0&id=1e8c17d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e8c17d2"]])

export default __exports__